import { render, staticRenderFns } from "./OverwriteBuilderTemplate.vue?vue&type=template&id=6035052e"
import script from "./OverwriteBuilderTemplate.vue?vue&type=script&lang=js"
export * from "./OverwriteBuilderTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports